/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52107.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class ApiAccountMiscControllerApi extends runtime.BaseAPI {
    /**
     */
    async checkInboxAvailableRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling checkInboxAvailable.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/check-inbox-available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async checkInboxAvailable(requestParameters, initOverrides) {
        const response = await this.checkInboxAvailableRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOnboardingSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.createOnboardingSubmissionOptions === null || requestParameters.createOnboardingSubmissionOptions === undefined) {
            throw new runtime.RequiredError('createOnboardingSubmissionOptions', 'Required parameter requestParameters.createOnboardingSubmissionOptions was null or undefined when calling createOnboardingSubmission.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/onboarding-submission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createOnboardingSubmissionOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOnboardingSubmission(requestParameters, initOverrides) {
        const response = await this.createOnboardingSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createOrUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.updateUserSettingsOptions === null || requestParameters.updateUserSettingsOptions === undefined) {
            throw new runtime.RequiredError('updateUserSettingsOptions', 'Required parameter requestParameters.updateUserSettingsOptions was null or undefined when calling createOrUpdateUserSettings.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateUserSettingsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createOrUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.createOrUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAllHasOnboardedFeaturesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-all-has-onboarded-features`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAllHasOnboardedFeatures(initOverrides) {
        const response = await this.deleteAllHasOnboardedFeaturesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAllOnboardingRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-all-onboarding`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAllOnboarding(initOverrides) {
        const response = await this.deleteAllOnboardingRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteHasOnboardedFeatureRaw(requestParameters, initOverrides) {
        if (requestParameters.feature === null || requestParameters.feature === undefined) {
            throw new runtime.RequiredError('feature', 'Required parameter requestParameters.feature was null or undefined when calling deleteHasOnboardedFeature.');
        }
        const queryParameters = {};
        if (requestParameters.feature !== undefined) {
            queryParameters['feature'] = requestParameters.feature;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/delete-has-onboarded-feature`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteHasOnboardedFeature(requestParameters, initOverrides) {
        const response = await this.deleteHasOnboardedFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async generateAndSetImapSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/imap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetImapSecrets(initOverrides) {
        const response = await this.generateAndSetImapSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async generateAndSetSmtpImapSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp-imap`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetSmtpImapSecrets(initOverrides) {
        const response = await this.generateAndSetSmtpImapSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async generateAndSetSmtpSecretsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async generateAndSetSmtpSecrets(initOverrides) {
        const response = await this.generateAndSetSmtpSecretsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAIPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/ai-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAIPlans1(initOverrides) {
        const response = await this.getAIPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountImapAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getAccountImapAccess.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getAccountImapAccess.');
        }
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getAccountImapAccess.');
        }
        const queryParameters = {};
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/imap`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccountImapAccess(requestParameters, initOverrides) {
        const response = await this.getAccountImapAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAccountSmtpAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) {
            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling getAccountSmtpAccess.');
        }
        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling getAccountSmtpAccess.');
        }
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling getAccountSmtpAccess.');
        }
        const queryParameters = {};
        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }
        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }
        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/smtp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAccountSmtpAccess(requestParameters, initOverrides) {
        const response = await this.getAccountSmtpAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAllUserStripeWebhookEventsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/get-all-stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAllUserStripeWebhookEvents(initOverrides) {
        const response = await this.getAllUserStripeWebhookEventsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getConnectorPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/connector-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getConnectorPlans1(initOverrides) {
        const response = await this.getConnectorPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsAutomationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/automations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsAutomations(initOverrides) {
        const response = await this.getDashMetricsAutomationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsNotificationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsNotifications(initOverrides) {
        const response = await this.getDashMetricsNotificationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsReputationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/reputation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsReputation(initOverrides) {
        const response = await this.getDashMetricsReputationRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getDashMetricsSubscriptionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/dash-metrics/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getDashMetricsSubscription(initOverrides) {
        const response = await this.getDashMetricsSubscriptionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmailPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/email-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmailPlans1(initOverrides) {
        const response = await this.getEmailPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventAggregatesSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/event-aggregates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventAggregatesSeries(requestParameters = {}, initOverrides) {
        const response = await this.getEventAggregatesSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventAggregatesSeriesListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/event-aggregates-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventAggregatesSeriesList(requestParameters = {}, initOverrides) {
        const response = await this.getEventAggregatesSeriesListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventAggregatesSeriesMapRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/event-aggregates-map`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventAggregatesSeriesMap(requestParameters = {}, initOverrides) {
        const response = await this.getEventAggregatesSeriesMapRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventAggregatesSeriesNamesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/event-aggregates-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventAggregatesSeriesNames(initOverrides) {
        const response = await this.getEventAggregatesSeriesNamesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getInvoicesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getInvoices(initOverrides) {
        const response = await this.getInvoicesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrCreateAccountInboxRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/account-inbox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOrCreateAccountInbox(initOverrides) {
        const response = await this.getOrCreateAccountInboxRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.usageRecordType !== undefined) {
            queryParameters['usageRecordType'] = requestParameters.usageRecordType;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/usage-records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecordSeries(requestParameters = {}, initOverrides) {
        const response = await this.getUsageRecordSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordSeries1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/usage-records-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecordSeries1(initOverrides) {
        const response = await this.getUsageRecordSeries1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordUpdatesSeriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.usageRecordType !== undefined) {
            queryParameters['usageRecordType'] = requestParameters.usageRecordType;
        }
        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }
        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/usage-record-updates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecordUpdatesSeries(requestParameters = {}, initOverrides) {
        const response = await this.getUsageRecordUpdatesSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserEventsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.names) {
            queryParameters['names'] = requestParameters.names;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserEvents(requestParameters = {}, initOverrides) {
        const response = await this.getUserEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserPlans1Raw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserPlans1(initOverrides) {
        const response = await this.getUserPlans1Raw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserSettingsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/user-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserSettings(initOverrides) {
        const response = await this.getUserSettingsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserStripeWebhookEventsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.names) {
            queryParameters['names'] = requestParameters.names;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserStripeWebhookEvents(requestParameters = {}, initOverrides) {
        const response = await this.getUserStripeWebhookEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getWebhookEventAggregatesSeriesListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.interval !== undefined) {
            queryParameters['interval'] = requestParameters.interval;
        }
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        if (requestParameters.phoneId !== undefined) {
            queryParameters['phoneId'] = requestParameters.phoneId;
        }
        if (requestParameters.webhookId !== undefined) {
            queryParameters['webhookId'] = requestParameters.webhookId;
        }
        if (requestParameters.eventType !== undefined) {
            queryParameters['eventType'] = requestParameters.eventType;
        }
        if (requestParameters.resultType !== undefined) {
            queryParameters['resultType'] = requestParameters.resultType;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/series/webhook-event-aggregates-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getWebhookEventAggregatesSeriesList(requestParameters = {}, initOverrides) {
        const response = await this.getWebhookEventAggregatesSeriesListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async grantAdminAccessToUserIdRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.message !== undefined) {
            queryParameters['message'] = requestParameters.message;
        }
        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }
        if (requestParameters.redirectDevUrl !== undefined) {
            queryParameters['redirectDevUrl'] = requestParameters.redirectDevUrl;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/grant`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async grantAdminAccessToUserId(requestParameters = {}, initOverrides) {
        const response = await this.grantAdminAccessToUserIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async hasMadeActionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/has-made-action`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async hasMadeAction(initOverrides) {
        const response = await this.hasMadeActionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async hasOnboardedFeaturesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/has-onboarded-features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async hasOnboardedFeatures(initOverrides) {
        const response = await this.hasOnboardedFeaturesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async saveHasOnboardedFeatureRaw(requestParameters, initOverrides) {
        if (requestParameters.feature === null || requestParameters.feature === undefined) {
            throw new runtime.RequiredError('feature', 'Required parameter requestParameters.feature was null or undefined when calling saveHasOnboardedFeature.');
        }
        const queryParameters = {};
        if (requestParameters.feature !== undefined) {
            queryParameters['feature'] = requestParameters.feature;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-has-onboarded-feature`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async saveHasOnboardedFeature(requestParameters, initOverrides) {
        const response = await this.saveHasOnboardedFeatureRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnblockDefaultSenderRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.unblockDefaultSenderRequestOptions === null || requestParameters.unblockDefaultSenderRequestOptions === undefined) {
            throw new runtime.RequiredError('unblockDefaultSenderRequestOptions', 'Required parameter requestParameters.unblockDefaultSenderRequestOptions was null or undefined when calling submitUnblockDefaultSenderRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unblock-default-sender-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unblockDefaultSenderRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnblockDefaultSenderRequest(requestParameters, initOverrides) {
        const response = await this.submitUnblockDefaultSenderRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnfreezeRequestRaw(requestParameters, initOverrides) {
        if (requestParameters.userUnfreezeRequestOptions === null || requestParameters.userUnfreezeRequestOptions === undefined) {
            throw new runtime.RequiredError('userUnfreezeRequestOptions', 'Required parameter requestParameters.userUnfreezeRequestOptions was null or undefined when calling submitUnfreezeRequest.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unfreeze-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userUnfreezeRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnfreezeRequest(requestParameters, initOverrides) {
        const response = await this.submitUnfreezeRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUnfreezeRequestAnonymousRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling submitUnfreezeRequestAnonymous.');
        }
        if (requestParameters.userUnfreezeRequestOptions === null || requestParameters.userUnfreezeRequestOptions === undefined) {
            throw new runtime.RequiredError('userUnfreezeRequestOptions', 'Required parameter requestParameters.userUnfreezeRequestOptions was null or undefined when calling submitUnfreezeRequestAnonymous.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/unfreeze-request-anonymous`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userUnfreezeRequestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async submitUnfreezeRequestAnonymous(requestParameters, initOverrides) {
        const response = await this.submitUnfreezeRequestAnonymousRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateAddNewContactsRaw(requestParameters, initOverrides) {
        if (requestParameters.updateAddNewContactsOptions === null || requestParameters.updateAddNewContactsOptions === undefined) {
            throw new runtime.RequiredError('updateAddNewContactsOptions', 'Required parameter requestParameters.updateAddNewContactsOptions was null or undefined when calling updateAddNewContacts.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-add-new-contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAddNewContactsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateAddNewContacts(requestParameters, initOverrides) {
        const response = await this.updateAddNewContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateHasOnboardedRaw(requestParameters, initOverrides) {
        if (requestParameters.updateHasOnboardedOptions === null || requestParameters.updateHasOnboardedOptions === undefined) {
            throw new runtime.RequiredError('updateHasOnboardedOptions', 'Required parameter requestParameters.updateHasOnboardedOptions was null or undefined when calling updateHasOnboarded.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-has-onboarded`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateHasOnboardedOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateHasOnboarded(requestParameters, initOverrides) {
        const response = await this.updateHasOnboardedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updatePrimaryEmailAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.updatePrimaryEmailAddressOptions === null || requestParameters.updatePrimaryEmailAddressOptions === undefined) {
            throw new runtime.RequiredError('updatePrimaryEmailAddressOptions', 'Required parameter requestParameters.updatePrimaryEmailAddressOptions was null or undefined when calling updatePrimaryEmailAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/update-email-address`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updatePrimaryEmailAddressOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updatePrimaryEmailAddress(requestParameters, initOverrides) {
        const response = await this.updatePrimaryEmailAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async waitForUserStripeWebhookEventsRaw(requestParameters, initOverrides) {
        if (requestParameters.timeout === null || requestParameters.timeout === undefined) {
            throw new runtime.RequiredError('timeout', 'Required parameter requestParameters.timeout was null or undefined when calling waitForUserStripeWebhookEvents.');
        }
        if (requestParameters.count === null || requestParameters.count === undefined) {
            throw new runtime.RequiredError('count', 'Required parameter requestParameters.count was null or undefined when calling waitForUserStripeWebhookEvents.');
        }
        const queryParameters = {};
        if (requestParameters.timeout !== undefined) {
            queryParameters['timeout'] = requestParameters.timeout;
        }
        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/account/wait-for-stripe-webhooks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async waitForUserStripeWebhookEvents(requestParameters, initOverrides) {
        const response = await this.waitForUserStripeWebhookEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const DeleteHasOnboardedFeatureFeatureEnum = {
    DASHBOARD: 'DASHBOARD',
    INTEGRATIONS: 'INTEGRATIONS',
    INBOXES: 'INBOXES',
    INBOXES_CREATE: 'INBOXES_CREATE',
    ORGANIZATIONS: 'ORGANIZATIONS',
    ORGANIZATIONS_CREATE: 'ORGANIZATIONS_CREATE',
    FORWARDING: 'FORWARDING',
    ALIASES: 'ALIASES',
    WEBHOOKS: 'WEBHOOKS'
};
/**
 * @export
 */
export const GetEventAggregatesSeriesIntervalEnum = {
    HOUR: 'HOUR',
    DAY: 'DAY'
};
/**
 * @export
 */
export const GetEventAggregatesSeriesListIntervalEnum = {
    HOUR: 'HOUR',
    DAY: 'DAY'
};
/**
 * @export
 */
export const GetUsageRecordSeriesUsageRecordTypeEnum = {
    EMAIL_VERIFICATION_REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    INBOUND_SMS: 'INBOUND_SMS',
    OUTBOUND_SMS: 'OUTBOUND_SMS',
    INBOX_CONNECTOR_SYNC: 'INBOX_CONNECTOR_SYNC',
    INBOX_CONNECTOR_SEND: 'INBOX_CONNECTOR_SEND',
    EMAIL_PLAN_INBOUND: 'EMAIL_PLAN_INBOUND',
    EMAIL_PLAN_OUTBOUND: 'EMAIL_PLAN_OUTBOUND',
    AI_TOKENS: 'AI_TOKENS',
    INBOX_CREATE: 'INBOX_CREATE',
    GUEST_USER_CREATE: 'GUEST_USER_CREATE',
    GUEST_USER_MAINTAIN: 'GUEST_USER_MAINTAIN'
};
/**
 * @export
 */
export const GetUsageRecordUpdatesSeriesUsageRecordTypeEnum = {
    EMAIL_VERIFICATION_REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    INBOUND_SMS: 'INBOUND_SMS',
    OUTBOUND_SMS: 'OUTBOUND_SMS',
    INBOX_CONNECTOR_SYNC: 'INBOX_CONNECTOR_SYNC',
    INBOX_CONNECTOR_SEND: 'INBOX_CONNECTOR_SEND',
    EMAIL_PLAN_INBOUND: 'EMAIL_PLAN_INBOUND',
    EMAIL_PLAN_OUTBOUND: 'EMAIL_PLAN_OUTBOUND',
    AI_TOKENS: 'AI_TOKENS',
    INBOX_CREATE: 'INBOX_CREATE',
    GUEST_USER_CREATE: 'GUEST_USER_CREATE',
    GUEST_USER_MAINTAIN: 'GUEST_USER_MAINTAIN'
};
/**
 * @export
 */
export const GetUserEventsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetUserStripeWebhookEventsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetWebhookEventAggregatesSeriesListIntervalEnum = {
    HOUR: 'HOUR',
    DAY: 'DAY'
};
/**
 * @export
 */
export const GetWebhookEventAggregatesSeriesListEventTypeEnum = {
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    NEW_EMAIL: 'NEW_EMAIL',
    NEW_CONTACT: 'NEW_CONTACT',
    NEW_ATTACHMENT: 'NEW_ATTACHMENT',
    EMAIL_OPENED: 'EMAIL_OPENED',
    EMAIL_READ: 'EMAIL_READ',
    DELIVERY_STATUS: 'DELIVERY_STATUS',
    BOUNCE: 'BOUNCE',
    BOUNCE_RECIPIENT: 'BOUNCE_RECIPIENT',
    NEW_SMS: 'NEW_SMS',
    NEW_GUEST_USER: 'NEW_GUEST_USER'
};
/**
 * @export
 */
export const GetWebhookEventAggregatesSeriesListResultTypeEnum = {
    BAD_RESPONSE: 'BAD_RESPONSE',
    EXCEPTION: 'EXCEPTION',
    SUCCESS: 'SUCCESS',
    REDRIVEN: 'REDRIVEN'
};
/**
 * @export
 */
export const SaveHasOnboardedFeatureFeatureEnum = {
    DASHBOARD: 'DASHBOARD',
    INTEGRATIONS: 'INTEGRATIONS',
    INBOXES: 'INBOXES',
    INBOXES_CREATE: 'INBOXES_CREATE',
    ORGANIZATIONS: 'ORGANIZATIONS',
    ORGANIZATIONS_CREATE: 'ORGANIZATIONS_CREATE',
    FORWARDING: 'FORWARDING',
    ALIASES: 'ALIASES',
    WEBHOOKS: 'WEBHOOKS'
};
